import React from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Color from "color"; // v3.2.1
import { brand } from "../theme/themePrimitives";

function truncate(str, maxNumOfChars) {
  return str.length > maxNumOfChars
    ? str.substring(0, maxNumOfChars - 3) + "..."
    : str;
}

const CardActionAreaActionArea = styled(CardActionArea)(() => ({
  borderRadius: 16,
  transition: "0.2s",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const StyledCard = styled(Card)(({ color }) => ({
  minWidth: 256,
  maxWidth: 200,
  padding: 0,
  borderRadius: 16,
  boxShadow: "none",
  "&:hover": {
    boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`,
  },
}));

const CardContentContent = styled(CardContent)(({ color }) => {
  return {
    backgroundColor: color,
    padding: "30px !important",
    minHeight: "196.8px",
  };
});

const TypographyTitle = styled(Typography)(() => ({
  fontSize: "1.6rem",
  color: brand.black,
  textTransform: "capitalize",
  lineHeight: "1.3em",
}));

const TypographySubtitle = styled(Typography)(() => ({
  color: brand.black,
  marginTop: "20px",
  fontWeight: 500,
  fontSize: "16px",
  textTransform: "none",
  paddingBottom: "40px",
}));

const CustomCard = ({ color, image, title, subtitle }) => (
  <CardActionAreaActionArea>
    <StyledCard color={color}>
      <CardMedia
        image={image}
        sx={{
          width: "100%",
          height: 0,
          paddingBottom: "75%",
          backgroundColor: "rgba(0,0,0,0.08)",
        }}
      />
      <CardContentContent color={color}>
        <TypographyTitle variant={"h2"} style={{ fontSize: "1.4rem" }}>
          {title}
        </TypographyTitle>
        <TypographySubtitle>{subtitle}</TypographySubtitle>
      </CardContentContent>
    </StyledCard>
  </CardActionAreaActionArea>
);

export function CardSolidGameCities({ dishes, cities }) {
  return (
    <>
      {cities && (
        <Grid container spacing={4} sx={{ justifyContent: "flex-start" }}>
          {cities.map((city, i) => (
            <Link to={`/cities/${city.title.toLowerCase()}`} key={city.id}>
              <Grid>
                <CustomCard
                  color={i % 2 === 0 ? brand.lightBlue : brand.yellow}
                  title={city.title}
                  subtitle={truncate(city.body, 60)}
                  image={city.image_url}
                />
              </Grid>
            </Link>
          ))}
        </Grid>
      )}
      {dishes && (
        <Grid container spacing={4} sx={{ justifyContent: "flex-start" }}>
          {dishes.map((dish, i) => (
            <Link to={`/dishes/${dish.id}`} key={dish.id}>
              <Grid>
                <CustomCard
                  color={i % 2 === 0 ? brand.lightBlue : brand.yellow}
                  title={dish.title}
                  subtitle={truncate(dish.body, 60)}
                  image={dish.image_url}
                />
              </Grid>
            </Link>
          ))}
        </Grid>
      )}
    </>
  );
}
